<template>
    <CRow
        v-if="showNotice"
        class="mb-3">
        <CCol>
            <CAlert
                color="info"
                :closeButton="false">
                <div class="d-flex align-items-start">
                    <div class="mr-3" style="font-size: 1.5rem;">
                        ℹ️
                    </div>
                    <div>
                        <h5 class="alert-heading mb-2">Внесение изменений недоступно</h5>
                        <p class="mb-0">
                            Ваш аккаунт имеет интеграцию с внешней системой. Изменения в меню и настройки
                            вносятся через вашу систему управления или через службу поддержки МИРСИТИ.
                        </p>
                        <p class="mb-0 mt-2">
                            <strong>Для внесения изменений обратитесь в службу поддержки.</strong>
                        </p>
                    </div>
                </div>
            </CAlert>
        </CCol>
    </CRow>
</template>

<script>
export default {
    name: 'IntegrationNotice',
    props: {
        hasIntegration: {
            type: Boolean,
            required: true,
            default: false
        },
        isBusinessAdmin: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    computed: {
        showNotice() {
            // Показывать плашку только для business_admin с интеграцией
            return this.isBusinessAdmin && this.hasIntegration;
        }
    }
};
</script>

<style scoped>
.alert-heading {
    font-weight: 600;
    color: #004085;
}

.alert p {
    line-height: 1.6;
}

.alert a {
    color: #004085;
    text-decoration: underline;
}

.alert a:hover {
    color: #002752;
}
</style>
